import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  load(e) {
    const el = e.currentTarget
    const loadingText = el.dataset.loading

    if (loadingText) {
      el.innerHTML = `<span class='far fa-spinner-third fa-spin'></span> ${loadingText}`
    } else {
      el.innerHTML = `<span class='far fa-spinner-third fa-spin'></span> ${i18n.t("js.loading")}`
    }
  }
}
